import {EventSubscriber, HasEventName} from "@/modules/base/events";
import {inject, injectable} from "inversify";
import {Suspension} from "@/modules/competitions/entity";
import {BeforeSeasonEvaluationEvent} from "@/modules/season/events/BeforeSeasonEvaluationEvent";
import {AfterPlayerSuspendedEvent} from "@/modules/competitions/events/AfterPlayerSuspendedEvent";
import {PlayerSuspendedNotification} from "@/modules/competitions/entity/PlayerSuspendedNotification";
import {Notifier} from "@/modules/notifications/services/Notifier";

@injectable()
export class SuspensionEventSubscriber implements EventSubscriber {
  constructor(
    @inject(Notifier) private notifier: Notifier,
  ) {}

  priority(): number {
    return 0;
  }

  init(): { event: HasEventName; callback: (event: any) => void }[] {
    return [
      {event: BeforeSeasonEvaluationEvent, callback: this.onBeforeSeasonEvaluationEvent},
      {event: AfterPlayerSuspendedEvent, callback: this.onAfterPlayerSuspendedEvent},
    ];
  }

  async onAfterPlayerSuspendedEvent(event: AfterPlayerSuspendedEvent): Promise<void> {
    if (!event.suspension.player.team!.user) {
      return;
    }

    const notification = new PlayerSuspendedNotification().setPayload(event.suspension);

    await this.notifier.notify(notification);
  }

  async onBeforeSeasonEvaluationEvent(event: BeforeSeasonEvaluationEvent): Promise<void> {
    await Suspension
      .createQueryBuilder('suspension')
      .delete()
      .execute();
  }
}
